module.exports = __webpack_public_path__ + "media/npc_dota_hero_sand_king.9263ea77.webm";